import { ventilation_supported_technology_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateVentilationSupportedTechnologyEnum = (enumValue: ventilation_supported_technology_enum) => {
  switch (enumValue) {
    case ventilation_supported_technology_enum.CENTRAL_EXHAUST:
      return <Trans i18nKey="Enum_VentilationSupportedTechnologyEnum-CENTRAL_EXHAUST" />;
    case ventilation_supported_technology_enum.CENTRAL_SUPPLY_EXHAUST_WITH_HRU:
      return <Trans i18nKey="Enum_VentilationSupportedTechnologyEnum-CENTRAL_SUPPLY_EXHAUST_WITH_HRU" />;
    case ventilation_supported_technology_enum.DECENTRAL_SINGLE_ROOM_VENTILATION_UNITS_WITH_HRU:
      return (
        <Trans i18nKey="Enum_VentilationSupportedTechnologyEnum-DECENTRAL_SINGLE_ROOM_VENTILATION_UNITS_WITH_HRU" />
      );
  }
};

export const translateVentilationSupportedTechnologyEnum_dynamic = (
  enumValue: ventilation_supported_technology_enum,
) => {
  const t = getI18n().t;
  switch (enumValue) {
    case ventilation_supported_technology_enum.CENTRAL_EXHAUST:
      return t('Enum_VentilationSupportedTechnologyEnum-CENTRAL_EXHAUST');
    case ventilation_supported_technology_enum.CENTRAL_SUPPLY_EXHAUST_WITH_HRU:
      return t('Enum_VentilationSupportedTechnologyEnum-CENTRAL_SUPPLY_EXHAUST_WITH_HRU');
    case ventilation_supported_technology_enum.DECENTRAL_SINGLE_ROOM_VENTILATION_UNITS_WITH_HRU:
      return t('Enum_VentilationSupportedTechnologyEnum-DECENTRAL_SINGLE_ROOM_VENTILATION_UNITS_WITH_HRU');
  }
};
